import { Directive, Input } from '@angular/core';

@Directive()
export abstract class LoaderBaseComponent {
  @Input() show = false;
}
